import React from "react";
import { useDispatch } from "react-redux";
import { toastAlert } from "@paylixecommerce/shared/components";
import SettingsCheckbox from "../components/SettingsCheckbox";
import SettingsHeader from "../components/SettingsHeader";
import SettingsSelect from "../components/SettingsSelect";
import SettingsSelectColor from "../components/SettingsSelectColor";
import SettingsSelectFont from "../components/SettingsSelectFont";
import SettingsSelectImage from "../components/SettingsSelectImage";
import SettingsSelectLink from "../components/SettingsSelectLink";
import SettingsSelectMenu from "../components/SettingsSelectMenu";
import SettingsSlider from "../components/SettingsSlider";
import SettingsText from "../components/SettingsText";
import loadable from "@loadable/component";

export const SettingsLinkText = loadable(() => import(/* webpackChunkName: "SettingsLinkText" */ "../components/SettingsLinkText"), { ssr: false });


export const getMenuComponent = (schemaValue, props) => {

  switch (schemaValue.type) {
    case 'header':
      return <SettingsHeader content={schemaValue?.content} />;

    case 'text':
      return <SettingsText {...props} />;

    case 'select':
      return <SettingsSelect {...props} />;

    case 'select-image':
      return <SettingsSelectImage {...props} />;

    case 'select-menu':
      return <SettingsSelectMenu {...props} />;

    case 'select-font':
      return <SettingsSelectFont {...props} />;

    case 'select-link':
      return <SettingsSelectLink {...props} />;

    case 'link-text':
      return <SettingsLinkText {...props} />;

    case 'checkbox':
      return <SettingsCheckbox {...props} />;

    case 'range':
      return <SettingsSlider {...props} />;

    case 'color-picker':
      return <SettingsSelectColor {...props} />;

    default:
      return toastAlert(
          'error',
          `The component for the <<<${schemaValue.type.toUpperCase()}>>> type is not ready yet`,
        );
  }
};
